import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Translation, TranslocoLoader } from '@jsverse/transloco';
import { catchError, forkJoin, map, Observable, of, take } from 'rxjs';
import { TRANSLATION_CATALOG_APPS } from './translation-catalogs.constant';

/**
 * Loads and merges flat JSON catalogs. Transloco resolves dotted keys via direct
 * property lookup first (`getValue`), so we keep flat keys (no unflatten).
 */
@Injectable({ providedIn: 'root' })
export class MergedTranslocoLoader implements TranslocoLoader {
    private readonly _http = inject(HttpClient);

    getTranslation(lang: string): Observable<Translation> {
        const reqs = TRANSLATION_CATALOG_APPS.map((app) =>
            this._http.get<Record<string, string>>(`./assets/vc-${app}/i18n/${lang}.json`).pipe(
                take(1),
                catchError(() => {
                    console.warn(`Failed to retrieve ${lang}.json for ${app}`);
                    return of({} as Record<string, string>);
                })
            )
        );

        return forkJoin(reqs).pipe(
            map((results) => results.reduce<Translation>((previous, current) => ({ ...previous, ...current }), {}))
        );
    }
}
